import { render, staticRenderFns } from "./DupesAreaVirtualTable.vue?vue&type=template&id=313dd565&scoped=true"
import script from "./DupesAreaVirtualTable.vue?vue&type=script&lang=js"
export * from "./DupesAreaVirtualTable.vue?vue&type=script&lang=js"
import style0 from "./DupesAreaVirtualTable.vue?vue&type=style&index=0&id=313dd565&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "313dd565",
  null
  
)

export default component.exports